import { render } from "./Benvenuto.vue?vue&type=template&id=c7f91dac&scoped=true"
import script from "./Benvenuto.vue?vue&type=script&lang=js"
export * from "./Benvenuto.vue?vue&type=script&lang=js"

import "./Benvenuto.vue?vue&type=style&index=0&id=c7f91dac&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7f91dac"]])

export default __exports__